import { useEffect, useState } from 'react';

const Toast = ({
  message = "",
  duration = 3000,
  centered = false,
}: {
  message?: string;
  duration?: number;
  centered?: boolean;
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  if (!isVisible) return null;

  return (
    <div
      className={
        centered ? "toast-container toast-container--centered" : "toast-container"
      }
    >
      <div className="toast-message">{message}</div>
    </div>
  );
};

export default Toast;